import { render, staticRenderFns } from "./SubscribeButton.vue?vue&type=template&id=0020359c&scoped=true"
import script from "./SubscribeButton.vue?vue&type=script&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&lang=js"
import style0 from "./SubscribeButton.vue?vue&type=style&index=0&id=0020359c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020359c",
  null
  
)

export default component.exports